/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [商品入库日志-标记异常异常状态↗](http://yapi.yishou.com/project/128/interface/api/35374) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/StockInRecord/editStockException`
 */
const editStockExceptionRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/editStockException",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "dbids",
            "markType",
            "is_pc",
            "exceptionSource",
            "file",
            "exceptionReasonSingle",
            "responsibilityDeptSingle",
            "responsibilityPersonal",
        ],
        properties: {
            dbids: { type: "string", description: "历史：逗号分隔" },
            markType: { type: "string", description: "下载模板，批量导入时需带上参数{1：标记异常，2：恢复正常}" },
            is_pc: { type: "string", description: "" },
            exceptionSource: { type: "string", description: "异常来源 (1:其他异常,4:改标异常)" },
            file: { type: "file", description: "", tsType: "FileData" },
            exceptionReasonSingle: { type: "string", description: "勾选标记异常时必填：异常原因id" },
            responsibilityDeptSingle: { type: "string", description: "勾选标记异常时选填：责任部门id" },
            responsibilityPersonal: { type: "string", description: "勾选标记异常时选填：责任人 | 任意字符串" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            errMsg: { type: "string", description: "错误描述" },
            file: { type: "string", description: "文件路径" },
        },
        required: ["file"],
    },
    requestFunctionName: "editStockException",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [商品入库日志-标记异常异常状态↗](http://yapi.yishou.com/project/128/interface/api/35374) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/StockInRecord/editStockException`
 */
export const editStockException = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editStockExceptionRequestConfig, requestData), ...args);
};
editStockException.requestConfig = editStockExceptionRequestConfig;
/**
 * 接口 [商品盘亏列表↗](http://yapi.yishou.com/project/128/interface/api/35383) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/inventoryLossesList`
 */
const inventoryLossesListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/inventoryLossesList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["created_at"],
        properties: {
            dbid: { type: "string", description: "打标id" },
            inventory_losses_no: { type: "string", description: "盘点单号" },
            storehouse_id: { type: "string", description: "仓库编号" },
            is_third_party: { type: "string", description: "是否第三方理赔：{1:是，2:否}" },
            goods_no: { type: "string", description: "货号" },
            sku: { type: "string", description: "sku编号" },
            supply_name: { type: "string", description: "商家名字符串" },
            market_name: { type: "string", description: "市场名字符串" },
            brand_name: { type: "string", description: "品牌名字符串" },
            stock_source: {
                type: "string",
                description: "入库来源id\n:  新入库类型{1:采购欠货,2:退换货欠货,3:售后欠货,4:售后拆包,5:调拨,6:现货调拨,7:核销,8:其他入库,9:生产盘盈,10:售后盘盈,11:旧前置仓,12:售后拆包错发核销,13:退换货其它入库,14:新前置仓,15:达人售后,16:售后拆包(退供),17:售后欠货(退供),18:买版计划,19:前置仓异常入库}",
            },
            source: { type: "string", description: "异常来源id:\n{1:其它异常,2:上架异常,3:盘点异常,4:改标异常}" },
            responsibility_department_id: { type: "string", description: "责任部门id" },
            submit_user: { type: "string", description: "提交盘亏人字符串" },
            is_excel: { type: "string", description: "是否导出：{1：是2：否}" },
            page: { type: "string", description: "页码" },
            page_size: { type: "string", description: "页面大小in:10,50,100,200,500,1000" },
            created_at: { type: "string", description: "创建时间，格式:Y-m-d H:m:s" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            count: { type: "number", description: "数据总数" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        inventory_losses_no: { type: "string", description: "盘点单号" },
                        dbid: { type: "string", description: "打标id" },
                        storehouse_id: { type: "string", description: "暂时无用：仓库id" },
                        is_third_party: { type: "string", description: "暂时无用：是否第三方理赔" },
                        goods_no: { type: "string", description: "货号" },
                        sku: { type: "string", description: "sku编号" },
                        supply_id: { type: "string", description: "暂时无用：供应商id" },
                        stock_source: { type: "string", description: "暂时无用：入库来源id" },
                        source: { type: "string", description: "暂时无用：异常来源id" },
                        cause_id: { type: "string", description: "暂时无用：异常原因ID" },
                        cause: { type: "string", description: "异常原因" },
                        responsibility_department_id: { type: "string", description: "暂时无用：责任部门ID" },
                        responsibility_department: { type: "string", description: "责任部门" },
                        responsibility_personnel: { type: "string", description: "责任人员" },
                        price: { type: "string", description: "采购价格" },
                        claim_price: { type: "string", description: "理赔金额" },
                        diff_price: { type: "string", description: "差额" },
                        exception_user: { type: "string", description: "暂时无用：标记异常人id" },
                        exception_time: { type: "string", description: "暂时无用：标记异常时间时间戳" },
                        submit_user: { type: "string", description: "暂时无用：提交盘亏人id" },
                        submit_time: { type: "string", description: "暂时无用：提交盘亏时间时间戳" },
                        created_at: { type: "string", description: "创建时间" },
                        goods_name: { type: "string", description: "商品名称" },
                        goods_img: { type: "string", description: "商品图片链接" },
                        brand_id: { type: "string", description: "暂时无用：品牌id" },
                        market_id: { type: "string", description: "暂时无用：市场id" },
                        cat_id: { type: "string", description: "暂时无用：商品分类id" },
                        storehouse_str: { type: "string", description: "仓库名" },
                        is_third_party_str: { type: "string", description: "是否第三方理赔" },
                        source_str: { type: "string", description: "异常来源" },
                        stock_source_str: { type: "string", description: "入库来源" },
                        category: { type: "string", description: "商品类目" },
                        co_si: { type: "string", description: "颜色尺码" },
                        market_name: { type: "string", description: "市场名" },
                        brand_name: { type: "string", description: "品牌名" },
                        supply_name: { type: "string", description: "供应商名" },
                        exception_user_str: { type: "string", description: "标记异常人" },
                        exception_time_str: { type: "string", description: "标记异常时间" },
                        submit_user_str: { type: "string", description: "提交盘亏人" },
                        submit_time_str: { type: "string", description: "提交盘亏时间" },
                    },
                },
            },
        },
    },
    requestFunctionName: "inventoryLossesList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [商品盘亏列表↗](http://yapi.yishou.com/project/128/interface/api/35383) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/inventoryLossesList`
 */
export const inventoryLossesList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(inventoryLossesListRequestConfig, requestData), ...args);
};
inventoryLossesList.requestConfig = inventoryLossesListRequestConfig;
/**
 * 接口 [盘亏-下载批量修改商品信息模板↗](http://yapi.yishou.com/project/128/interface/api/35419) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `GET /erp/InventoryLosses/exportClaimPriceDemo`
 */
const exportClaimPriceDemoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/exportClaimPriceDemo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string", description: "文件下载链接" } } },
    requestFunctionName: "exportClaimPriceDemo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-下载批量修改商品信息模板↗](http://yapi.yishou.com/project/128/interface/api/35419) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `GET /erp/InventoryLosses/exportClaimPriceDemo`
 */
export const exportClaimPriceDemo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportClaimPriceDemoRequestConfig, requestData), ...args);
};
exportClaimPriceDemo.requestConfig = exportClaimPriceDemoRequestConfig;
/**
 * 接口 [盘亏-更新理赔金额↗](http://yapi.yishou.com/project/128/interface/api/35428) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/editClaimPrice`
 */
const editClaimPriceRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/editClaimPrice",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "dbid", "claim_price"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            dbid: { type: "string", description: "打标ID" },
            claim_price: { type: "string", description: "理赔金额" },
        },
    },
    responseDataJsonSchema: { type: "array", description: "[]" },
    requestFunctionName: "editClaimPrice",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-更新理赔金额↗](http://yapi.yishou.com/project/128/interface/api/35428) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/editClaimPrice`
 */
export const editClaimPrice = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(editClaimPriceRequestConfig, requestData), ...args);
};
editClaimPrice.requestConfig = editClaimPriceRequestConfig;
/**
 * 接口 [盘亏-获取盘亏单操作日志↗](http://yapi.yishou.com/project/128/interface/api/35437) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/getCheckLog`
 */
const getCheckLogRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/getCheckLog",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "page", "page_size"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            page: { type: "string", description: "页码" },
            page_size: { type: "string", description: "页码长度" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number", description: "数据总数" },
            page: { type: "string", description: "页数" },
            page_size: { type: "string", description: "页面长度" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "日志自增id" },
                        inventory_losses_id: { type: "string", description: "盘亏单ID" },
                        admin_id: { type: "string", description: "操作人" },
                        operate_type: {
                            type: "string",
                            description: "操作方式:{1:创建盘亏单;2:仓储审核通过;3:仓储审核驳回;4:仓储组长审核通过;5:仓储组长审核驳回;6:会计审核通过;7:会计审核驳回;8:财务组长审核通过;9:财务组长审核驳回;10:作废盘亏单;11:提交盘亏单;12:导入批量修改信息;}",
                        },
                        remark: { type: "string", description: "备注" },
                        created_at: { type: "string", description: "创建时间" },
                        updated_at: { type: "string", description: "更新时间" },
                        admin_name: { type: "string", description: "操作人名称" },
                        operate_type_text: { type: "string", description: "操作方式字面量" },
                    },
                },
            },
        },
    },
    requestFunctionName: "getCheckLog",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-获取盘亏单操作日志↗](http://yapi.yishou.com/project/128/interface/api/35437) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/getCheckLog`
 */
export const getCheckLog = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCheckLogRequestConfig, requestData), ...args);
};
getCheckLog.requestConfig = getCheckLogRequestConfig;
/**
 * 接口 [盘亏-会计审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35455) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/accountantCheckReject`
 */
const accountantCheckRejectRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/accountantCheckReject",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "accountantCheckReject",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-会计审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35455) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/accountantCheckReject`
 */
export const accountantCheckReject = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(accountantCheckRejectRequestConfig, requestData), ...args);
};
accountantCheckReject.requestConfig = accountantCheckRejectRequestConfig;
/**
 * 接口 [盘亏-仓储组长审核通过↗](http://yapi.yishou.com/project/128/interface/api/35464) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageLeaderCheckPass`
 */
const storageLeaderCheckPassRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/storageLeaderCheckPass",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "storageLeaderCheckPass",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-仓储组长审核通过↗](http://yapi.yishou.com/project/128/interface/api/35464) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageLeaderCheckPass`
 */
export const storageLeaderCheckPass = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(storageLeaderCheckPassRequestConfig, requestData), ...args);
};
storageLeaderCheckPass.requestConfig = storageLeaderCheckPassRequestConfig;
/**
 * 接口 [盘亏-仓储组长审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35473) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageLeaderCheckReject`
 */
const storageLeaderCheckRejectRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/storageLeaderCheckReject",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "storageLeaderCheckReject",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-仓储组长审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35473) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageLeaderCheckReject`
 */
export const storageLeaderCheckReject = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(storageLeaderCheckRejectRequestConfig, requestData), ...args);
};
storageLeaderCheckReject.requestConfig = storageLeaderCheckRejectRequestConfig;
/**
 * 接口 [盘亏-会计审核通过↗](http://yapi.yishou.com/project/128/interface/api/35482) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/accountantCheckPass`
 */
const accountantCheckPassRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/accountantCheckPass",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "accountantCheckPass",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-会计审核通过↗](http://yapi.yishou.com/project/128/interface/api/35482) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/accountantCheckPass`
 */
export const accountantCheckPass = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(accountantCheckPassRequestConfig, requestData), ...args);
};
accountantCheckPass.requestConfig = accountantCheckPassRequestConfig;
/**
 * 接口 [盘亏-仓储审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35491) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageCheckReject`
 */
const storageCheckRejectRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/storageCheckReject",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "storageCheckReject",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-仓储审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35491) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageCheckReject`
 */
export const storageCheckReject = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(storageCheckRejectRequestConfig, requestData), ...args);
};
storageCheckReject.requestConfig = storageCheckRejectRequestConfig;
/**
 * 接口 [盘亏- 财务组长审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35500) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/cwLeaderCheckReject`
 */
const cwLeaderCheckRejectRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/cwLeaderCheckReject",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "cwLeaderCheckReject",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏- 财务组长审核驳回↗](http://yapi.yishou.com/project/128/interface/api/35500) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/cwLeaderCheckReject`
 */
export const cwLeaderCheckReject = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cwLeaderCheckRejectRequestConfig, requestData), ...args);
};
cwLeaderCheckReject.requestConfig = cwLeaderCheckRejectRequestConfig;
/**
 * 接口 [盘亏-财务组长审核通过↗](http://yapi.yishou.com/project/128/interface/api/35509) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/cwLeaderCheckPass`
 */
const cwLeaderCheckPassRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/cwLeaderCheckPass",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "cwLeaderCheckPass",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-财务组长审核通过↗](http://yapi.yishou.com/project/128/interface/api/35509) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/cwLeaderCheckPass`
 */
export const cwLeaderCheckPass = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cwLeaderCheckPassRequestConfig, requestData), ...args);
};
cwLeaderCheckPass.requestConfig = cwLeaderCheckPassRequestConfig;
/**
 * 接口 [盘亏-仓储审核通过↗](http://yapi.yishou.com/project/128/interface/api/35518) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageCheckPass`
 */
const storageCheckPassRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/storageCheckPass",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "storageCheckPass",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-仓储审核通过↗](http://yapi.yishou.com/project/128/interface/api/35518) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/storageCheckPass`
 */
export const storageCheckPass = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(storageCheckPassRequestConfig, requestData), ...args);
};
storageCheckPass.requestConfig = storageCheckPassRequestConfig;
/**
 * 接口 [盘亏-作废盘亏单↗](http://yapi.yishou.com/project/128/interface/api/35527) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/cancelledCheck`
 */
const cancelledCheckRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/cancelledCheck",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "cancelledCheck",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-作废盘亏单↗](http://yapi.yishou.com/project/128/interface/api/35527) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/cancelledCheck`
 */
export const cancelledCheck = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cancelledCheckRequestConfig, requestData), ...args);
};
cancelledCheck.requestConfig = cancelledCheckRequestConfig;
/**
 * 接口 [盘亏-提交盘亏单↗](http://yapi.yishou.com/project/128/interface/api/35536) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/submitCheck`
 */
const submitCheckRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/submitCheck",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            status: { type: "string", description: "当前状态" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "submitCheck",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-提交盘亏单↗](http://yapi.yishou.com/project/128/interface/api/35536) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/submitCheck`
 */
export const submitCheck = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(submitCheckRequestConfig, requestData), ...args);
};
submitCheck.requestConfig = submitCheckRequestConfig;
/**
 * 接口 [盘亏-获取盘亏单详情↗](http://yapi.yishou.com/project/128/interface/api/35545) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/getCheckInfo`
 */
const getCheckInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/getCheckInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "盘亏审核单ID" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            id: { type: "string", description: "盘亏单ID" },
            inventory_losses_no: { type: "string", description: "盘亏单号" },
            storehouse_id: { type: "string", description: "仓库ID" },
            is_third_party: { type: "string", description: "是否第三方理赔:{1:是;2:否}" },
            total_num: { type: "string", description: "商品总数量" },
            total_amount: { type: "string", description: "商品总金额" },
            total_claim_amount: { type: "string", description: "理赔总金额" },
            total_diff_price: { type: "string", description: "差额总金额" },
            status: {
                type: "string",
                description: "盘亏单状态:{1:待修改;2:待重新提交;3:仓储待审核;4:仓储组长待审核;5:会计待审核;6:财务组长待审核;7:已完成;8:已作废;}",
            },
            create_user: { type: "string", description: "创建人" },
            remark: { type: "null", description: "备注" },
            submit_user: { type: "string", description: "提交人" },
            submit_time: { type: "string", description: "提交时间" },
            storage_auditor_user: { type: "string", description: "仓储审核人" },
            storage_auditor_time: { type: "string", description: "仓储审核时间" },
            sl_auditor_user: { type: "string", description: "仓储组长审核人" },
            sl_auditor_time: { type: "string", description: "仓储组长审核时间" },
            accountant_auditor_user: { type: "string", description: "会计审核人" },
            accountant_auditor_time: { type: "string", description: "会计审核时间" },
            al_auditor_user: { type: "string", description: "财务组长审核人" },
            al_auditor_time: { type: "string", description: "财务组长审核时间" },
            finish_time: { type: "string", description: "完成时间" },
            created_at: { type: "string", description: "创建时间" },
            updated_at: { type: "string", description: "更新时间" },
            status_text: { type: "string", description: "状态字面量" },
        },
    },
    requestFunctionName: "getCheckInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏-获取盘亏单详情↗](http://yapi.yishou.com/project/128/interface/api/35545) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/getCheckInfo`
 */
export const getCheckInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCheckInfoRequestConfig, requestData), ...args);
};
getCheckInfo.requestConfig = getCheckInfoRequestConfig;
/**
 * 接口 [盘亏 - 批量修改商品信息↗](http://yapi.yishou.com/project/128/interface/api/35572) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/claimPriceBatchEdit`
 */
const claimPriceBatchEditRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/claimPriceBatchEdit",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "excel"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            excel: { type: "file", description: "导入文件", tsType: "FileData" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            file: { type: "string", description: "导出文件（如果全部成功，则不生成，为空）" },
            error_count: { type: "number", description: "失败条数" },
            succeed_count: { type: "number", description: "成功条数" },
        },
    },
    requestFunctionName: "claimPriceBatchEdit",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏 - 批量修改商品信息↗](http://yapi.yishou.com/project/128/interface/api/35572) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/claimPriceBatchEdit`
 */
export const claimPriceBatchEdit = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(claimPriceBatchEditRequestConfig, requestData), ...args);
};
claimPriceBatchEdit.requestConfig = claimPriceBatchEditRequestConfig;
/**
 * 接口 [盘亏审核列表↗](http://yapi.yishou.com/project/128/interface/api/35662) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/checkList`
 */
const checkListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/checkList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "create_time[]",
            "finish_time[]",
            "inventory_losses_no",
            "storehouse_id",
            "is_third_party",
            "user_name",
            "status[]",
            "is_excel",
        ],
        properties: {
            "create_time[]": { type: "string" },
            "finish_time[]": { type: "string", description: "" },
            inventory_losses_no: { type: "string", description: "" },
            storehouse_id: { type: "string", description: "仓库id" },
            is_third_party: { type: "string", description: "是否第三方理赔:{1:是;2:否}" },
            user_name: { type: "string", description: "" },
            "status[]": {
                type: "string",
                description: "盘亏单状态:{1:待修改;2:待重新提交;3:仓储待审核;4:仓储组长待审核;5:会计待审核;6:财务组长待审核;7:已完成;8:已作废;}",
            },
            is_excel: { type: "string", description: "是否导出 0 否 1 导出列表 2 导出商品明细" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number" },
            page: { type: "number" },
            page_size: { type: "number" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string" },
                        inventory_losses_no: { type: "string", description: "盘亏单号" },
                        storehouse_id: { type: "string" },
                        is_third_party: { type: "string" },
                        total_num: { type: "string", description: "商品总数量" },
                        total_amount: { type: "string", description: "商品总金额" },
                        total_claim_amount: { type: "string", description: "理赔总金额" },
                        total_diff_price: { type: "string", description: "总差额" },
                        status: { type: "string" },
                        create_user: { type: "string" },
                        remark: { type: "null" },
                        submit_user: { type: "string" },
                        submit_time: { type: "string" },
                        storage_auditor_user: { type: "string" },
                        storage_auditor_time: { type: "string" },
                        sl_auditor_user: { type: "string" },
                        sl_auditor_time: { type: "string" },
                        accountant_auditor_user: { type: "string" },
                        accountant_auditor_time: { type: "string" },
                        al_auditor_user: { type: "string" },
                        al_auditor_time: { type: "string" },
                        finish_time: { type: "string" },
                        created_at: { type: "string", description: "创建时间" },
                        updated_at: { type: "string" },
                        storehouse: { type: "string", description: "仓库" },
                        is_third_party_text: { type: "string", description: "是否第三方理赔" },
                        status_text: { type: "string", description: "盘亏单状态" },
                        create_user_name: { type: "string", description: "创建人" },
                        submit_user_name: { type: "string", description: "提交人" },
                        storage_auditor_user_name: { type: "string", description: "仓储审核人" },
                        sl_auditor_user_name: { type: "string", description: "仓储组长审核人" },
                        accountant_auditor_user_name: { type: "string", description: "会计审核人" },
                        al_auditor_user_name: { type: "string", description: "财务组长审核人" },
                        submit_time_date: { type: "string", description: "提交时间" },
                        storage_auditor_time_date: { type: "string", description: "仓储审核时间" },
                        sl_auditor_time_date: { type: "string", description: "仓储组长审核时间" },
                        accountant_auditor_time_date: { type: "string", description: "会计审核时间" },
                        al_auditor_time_date: { type: "string", description: "财务组长审核时间" },
                        finish_time_date: { type: "string", description: "完成时间" },
                    },
                    required: [
                        "id",
                        "inventory_losses_no",
                        "storehouse_id",
                        "is_third_party",
                        "total_num",
                        "total_amount",
                        "total_claim_amount",
                        "total_diff_price",
                        "status",
                        "create_user",
                        "remark",
                        "submit_user",
                        "submit_time",
                        "storage_auditor_user",
                        "storage_auditor_time",
                        "sl_auditor_user",
                        "sl_auditor_time",
                        "accountant_auditor_user",
                        "accountant_auditor_time",
                        "al_auditor_user",
                        "al_auditor_time",
                        "finish_time",
                        "created_at",
                        "updated_at",
                        "storehouse",
                        "is_third_party_text",
                        "status_text",
                        "create_user_name",
                        "submit_user_name",
                        "storage_auditor_user_name",
                        "sl_auditor_user_name",
                        "accountant_auditor_user_name",
                        "al_auditor_user_name",
                        "submit_time_date",
                        "storage_auditor_time_date",
                        "sl_auditor_time_date",
                        "accountant_auditor_time_date",
                        "al_auditor_time_date",
                        "finish_time_date",
                    ],
                },
            },
        },
    },
    requestFunctionName: "checkList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏审核列表↗](http://yapi.yishou.com/project/128/interface/api/35662) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/checkList`
 */
export const checkList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(checkListRequestConfig, requestData), ...args);
};
checkList.requestConfig = checkListRequestConfig;
/**
 * 接口 [盘亏审核单-商品详情↗](http://yapi.yishou.com/project/128/interface/api/35671) 的 **请求配置**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/getCheckGoodsInfo`
 */
const getCheckGoodsInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryLosses/getCheckGoodsInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "is_excel", "page", "page_size"],
        properties: {
            id: { type: "string", description: "盘亏审核单ID" },
            is_excel: { type: "string", description: " 是否导出 0 否 1 导出" },
            page: { type: "string", description: "" },
            page_size: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number" },
            page: { type: "number" },
            page_size: { type: "number" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        inventory_losses_no: { type: "string" },
                        storehouse_id: { type: "string" },
                        is_third_party: { type: "string" },
                        status: { type: "string" },
                        create_user: { type: "string" },
                        created_at: { type: "string" },
                        id: { type: "string" },
                        inventory_losses_id: { type: "string" },
                        dbid: { type: "string", description: "打标ID" },
                        goods_no: { type: "string", description: "货号" },
                        co_val: { type: "string", description: "颜色" },
                        si_val: { type: "string" },
                        sku: { type: "string", description: "sku" },
                        supply_id: { type: "string" },
                        stock_source: { type: "string" },
                        source: { type: "string" },
                        cause_id: { type: "string" },
                        responsibility_department_id: { type: "string" },
                        responsibility_personnel: { type: "string", description: "责任人" },
                        price: { type: "string", description: "商品采购价" },
                        claim_price: { type: "string", description: "理赔金额" },
                        diff_price: { type: "string", description: "差额" },
                        edit_user: { type: "string" },
                        edit_time: { type: "string" },
                        exception_user: { type: "string" },
                        exception_time: { type: "string" },
                        storehouse: { type: "string" },
                        is_third_party_text: { type: "string" },
                        status_text: { type: "string", description: "异常来源" },
                        create_user_name: { type: "string" },
                        edit_user_name: { type: "string", description: "修改人" },
                        exception_user_name: { type: "string", description: "标记异常人" },
                        edit_time_date: { type: "string", description: "修改时间" },
                        exception_time_date: { type: "string", description: "标记异常时间" },
                        cause: { type: "string", description: "异常原因" },
                        responsibility_department: { type: "string", description: "责任部门" },
                        stock_source_text: { type: "string", description: "入库来源" },
                        goods_info_text: { type: "string", description: "品货号/颜色/尺码" },
                        goods_name: { type: "string", description: "商品名称" },
                        goods_img: { type: "array", items: { type: "string" }, description: "商品图片" },
                        cat_name: { type: "string", description: "商品分类" },
                        supply_info_text: { type: "string", description: "商家/市场/品牌" },
                    },
                    required: [
                        "inventory_losses_no",
                        "storehouse_id",
                        "is_third_party",
                        "status",
                        "create_user",
                        "created_at",
                        "id",
                        "inventory_losses_id",
                        "dbid",
                        "goods_no",
                        "co_val",
                        "si_val",
                        "sku",
                        "supply_id",
                        "stock_source",
                        "source",
                        "cause_id",
                        "responsibility_department_id",
                        "responsibility_personnel",
                        "price",
                        "claim_price",
                        "diff_price",
                        "edit_user",
                        "edit_time",
                        "exception_user",
                        "exception_time",
                        "storehouse",
                        "is_third_party_text",
                        "status_text",
                        "create_user_name",
                        "edit_user_name",
                        "exception_user_name",
                        "edit_time_date",
                        "exception_time_date",
                        "cause",
                        "responsibility_department",
                        "stock_source_text",
                        "goods_info_text",
                        "goods_name",
                        "goods_img",
                        "cat_name",
                        "supply_info_text",
                    ],
                },
            },
        },
    },
    requestFunctionName: "getCheckGoodsInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [盘亏审核单-商品详情↗](http://yapi.yishou.com/project/128/interface/api/35671) 的 **请求函数**
 *
 * @分类 [商品管理↗](http://yapi.yishou.com/project/128/interface/api/cat_3642)
 * @请求头 `POST /erp/InventoryLosses/getCheckGoodsInfo`
 */
export const getCheckGoodsInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCheckGoodsInfoRequestConfig, requestData), ...args);
};
getCheckGoodsInfo.requestConfig = getCheckGoodsInfoRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/goodsManage3642.js